import React from 'react'

import { Text, FontFamily, FontWeight, Color, Display } from '@gousto-internal/citrus-react'
import { isRecipeFineDineIn, Recipe } from '@library/menu-service'

export const CaloriesText = ({ recipe }: { recipe: Recipe }) => {
  const isFineDineIn = isRecipeFineDineIn(recipe)

  const caloriesToDisplay = recipe.nutritionalInformation.perPortion.energyKcal

  if (!caloriesToDisplay) {
    return null
  }

  return (
    <Text
      size={2}
      fontFamily={FontFamily.Book}
      fontWeight={FontWeight.Normal}
      color={isFineDineIn ? Color.White : Color.ColdGrey_600}
      display={Display.Inline}
    >
      &nbsp;&nbsp;|&nbsp;&nbsp;{`${caloriesToDisplay} kcal`}
    </Text>
  )
}
